import {
  CREATE_MPF_PERFIL,
  DELETE_MPF_PERFIL,
  GET_MPF_PERFIS_CATALOGO,
  GET_MPF_PERMISSOES,
  LIST_MPF_PERFIS,
  UPDATE_MPF_PERFIL,
} from 'volto-ministerio-publico-federal/constants';

/**
 * Permissões de interface efetivas do usuário autenticado (`@mpf-permissoes`).
 * Carregado a cada troca de token pelo `MpfPermissoesLoader`.
 */
export function getMpfPermissoes() {
  return {
    type: GET_MPF_PERMISSOES,
    request: { op: 'get', path: '/@mpf-permissoes' },
  };
}

// CRUD dos perfis de acesso: o backend só responde ao Manager.

export function listMpfPerfis() {
  return {
    type: LIST_MPF_PERFIS,
    request: { op: 'get', path: '/@mpf-perfis' },
  };
}

export function getMpfPerfisCatalogo() {
  return {
    type: GET_MPF_PERFIS_CATALOGO,
    request: { op: 'get', path: '/@mpf-perfis-catalogo' },
  };
}

export function createMpfPerfil(data: Record<string, unknown>) {
  return {
    type: CREATE_MPF_PERFIL,
    request: { op: 'post', path: '/@mpf-perfis', data },
  };
}

export function updateMpfPerfil(id: string, data: Record<string, unknown>) {
  return {
    type: UPDATE_MPF_PERFIL,
    request: { op: 'patch', path: `/@mpf-perfis/${id}`, data },
  };
}

export function deleteMpfPerfil(id: string) {
  return {
    type: DELETE_MPF_PERFIL,
    request: { op: 'del', path: `/@mpf-perfis/${id}` },
  };
}
